import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import {
  MarketingHeader, MarketingFooter, MarketingBackdrop,
} from "@/components/MarketingShell";

export default function NotFoundPage() {
  return (
    <MarketingBackdrop>
      <SEO
        path="/404"
        title="Page not found — PowerBuilt"
        description="The page you're looking for doesn't exist. Return to PowerBuilt's homepage or explore our solar, electrical and maintenance services."
        noindex
      />
      <MarketingHeader />
      <main className="relative z-10 max-w-2xl mx-auto px-6 py-24 text-center">
        <p className="overline text-[#C9A356] mb-4">404</p>
        <h1 className="text-4xl sm:text-5xl font-heading font-medium tracking-tight">
          This page has drifted out to sea.
        </h1>
        <p className="mt-6 text-lg text-slate-300 leading-relaxed">
          The link you followed doesn&#39;t point anywhere on PowerBuilt. Try one of these instead:
        </p>
        <div className="mt-10 flex flex-wrap gap-4 justify-center">
          <Link to="/"            className="btn-accent px-6 py-3">Homepage</Link>
          <Link to="/solar"       className="px-6 py-3 rounded-md border border-white/20 hover:bg-white/10 transition">Solar</Link>
          <Link to="/electrical"  className="px-6 py-3 rounded-md border border-white/20 hover:bg-white/10 transition">Electrical</Link>
          <Link to="/maintenance" className="px-6 py-3 rounded-md border border-white/20 hover:bg-white/10 transition">Maintenance</Link>
          <Link to="/contact"     className="px-6 py-3 rounded-md border border-white/20 hover:bg-white/10 transition">Contact</Link>
        </div>
      </main>
      <MarketingFooter />
    </MarketingBackdrop>
  );
}
